// types
import { IField, IFieldValueMapItem, IParentFormPropertiesItem, IRisk, IRiskTemplate } from 'types/graphql'

export interface IParentFieldMapping {
  riskTemplateId: string
  fieldIds: string[]
}

export interface IParentFieldsGroup {
  key: string
  record: IRisk
  fields: IField[]
  fieldValues: IFieldValueMapItem[]
}

// One group per mainRisk and, if there is one, its own parentRisk — not the whole chain: ancestors
// in between are RecordLinks' breadcrumb's concern, not this flat list's.
export const getParentFieldsGroups = ({
  results,
  riskTemplates,
  fieldMappings
}: {
  results: IParentFormPropertiesItem[]
  riskTemplates: IRiskTemplate[]
  fieldMappings: IParentFieldMapping[]
}): IParentFieldsGroup[] =>
  results.flatMap((result, resultIdx) => {
    const records = [result.parentRisk, result.mainRisk].filter(Boolean) as IRisk[]

    return records
      .map((record, recordIdx) => {
        const templateId = record.riskTemplate?.id
        const template = riskTemplates.find(({ id }) => id === templateId)
        const mapping = fieldMappings.find(({ riskTemplateId }) => riskTemplateId === templateId)

        const fields = (mapping?.fieldIds ?? [])
          .map((fieldId) => template?.fields.find(({ id }) => id === fieldId))
          .filter(Boolean) as IField[]

        return {
          fields,
          record,
          key: `${resultIdx}_${recordIdx}_${record.id ?? templateId}`,
          fieldValues: (result.fieldValues ?? []).filter(({ entityId }) => entityId === templateId)
        }
      })
      .filter(({ fields }) => fields.length)
  })
